import type { VisitType } from '../types';

export const MARKER_COLORS: Record<VisitType, string> = {
  solo:     '#2196F3',
  family:   '#4CAF50',
  group:    '#FF9800',
  markanya: '#E91E63',
};

export const PERSON_COLORS: Record<string, string> = {
  Mark:     '#2196F3',
  Anya:     '#9C27B0',
  Victoria: '#00BCD4',
  Liam:     '#FF5722',
};

export const UNVISITED_COLOR = '#9E9E9E';

export function getMarkerColor(visitType: VisitType | null | undefined, soloTraveller?: string | null): string {
  if (!visitType) return UNVISITED_COLOR;
  if (visitType === 'solo' && soloTraveller && PERSON_COLORS[soloTraveller]) {
    return PERSON_COLORS[soloTraveller];
  }
  return MARKER_COLORS[visitType] ?? UNVISITED_COLOR;
}
